import { API_BASE_URL } from "../constant";

export const createSubmission = (data) =>
  API_BASE_URL.post("submission", data);

export const getCompanyResponses = (companyId, page, limit) =>
  API_BASE_URL.get(`submission/company/${companyId}`, {
    params: { page, limit },
  });

export const getCompanyResponsesByStatus = (
  companyId,
  status,
  page,
  limit,
  searchTerm,
  timePeriod
) =>
  API_BASE_URL.get(`submission/company/status/${companyId}`, {
    params: { page, limit, searchTerm, timePeriod, status },
  });

export const getAllResponsesWithCount = (companyId) =>
  API_BASE_URL.get(`submission/counts/${companyId}`);

export const getAllResponses = () => API_BASE_URL.get("submission");

export const getDataInCsv = () => API_BASE_URL.get("submission/export");

export const getSubmission = (id) =>
  API_BASE_URL.get(`submission/${id}`);

